import { Button, ButtonProps } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';

import { SxPropsOverrides } from '../../../shared/types/markup';
import { applySxOverrides } from '../../../shared/helpers/functions/markup';

export default function CtaButton({
  label,
  to,
  variant = 'contained',
  disabled,
  styles,
  onClick,
}: {
  label: string;
  to?: string;
  variant?: ButtonProps['variant'];
  disabled?: boolean;
  styles?: SxPropsOverrides;
  onClick?: () => void;
}) {
  return (
    <Button
      variant={variant}
      component={to ? RouterLink : 'button'}
      disabled={disabled}
      to={to}
      target="_top"
      sx={(theme) => ({
        fontSize: '20px',
        lineHeight: '20px',
        pt: '12px',
        pb: '12px',
        minHeight: '45px',
        borderColor: theme.palette.primary.main,
        '&:hover': {
          backgroundColor: theme.palette.primary.light,
          color: theme.palette.common.white,
        },
        ...applySxOverrides(styles, theme),
      })}
      onClick={onClick}
    >
      {label}
    </Button>
  );
}
